import React from "react";

const Pages_Faqs = () => {
  return <div>Pages_Faqs</div>;
};

export default Pages_Faqs;
